import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

import { pusher } from "../services/pusherService.js";
import { selectCurrentUser } from "../store/user/userSelector";
import BackIcon from "../icons/BackIcon.jsx";
import cogoToast from "cogo-toast";
import { useParams, useNavigate } from "react-router-dom";
import ApexChart from "react-apexcharts";
import SimpleSpinner from "../components/Loader/SimpleSpinner";
import NotFound from "../components/NotFound/NotFound";
import { BASE_WEB_URL } from "../CONSTANTS";
import { fetchTweet } from "../store/Tweet/tweetActions";
import TextButton from "../components/Button/TextButton/TextButton";
import { fToNowAr } from "../utils/format";
import { reactToProject, upvoteOpenProject } from "../services/tweetService";
import {
  CONSTITUTION_TWEET_LIKED_SUCCESS,
  FETCHING_TWEET_SUCCESS,
  TWEET_LIKED_SUCCESS,
} from "../store/Tweet/tweetSlice";

export default function Tweetpage() {
  const dispatch = useDispatch();
  const { tweetid } = useParams();
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const currentUser = selectCurrentUser(state);
  const tweet = useSelector((state) => state.tweet.tweet);
  const fetching = useSelector((state) => state.tweet.fetching);
  const fetchingTweetError = useSelector(
    (state) => state.tweet.fetchingTweetError
  );
  const locale = {
    name: "ar",
    options: {
      months: [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر",
      ],
      shortMonths: [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر",
      ],
      days: [
        "الأحد",
        "الإثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت",
      ],
      shortDays: ["أحد", "إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
      toolbar: {
        exportToSVG: "تحميل بصيغة SVG",
        exportToPNG: "تحميل بصيغة PNG",
        exportToCSV: "تحميل بصيغة CSV",
        menu: "القائمة",
        selection: "تحديد",
        selectionZoom: "تكبير التحديد",
        zoomIn: "تكبير",
        zoomOut: "تصغير",
        pan: "تحريك",
        reset: "إعادة التعيين",
      },
    },
  };
  const goBack = () => {
    navigate(-1);
  };
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    let cleanupEventListener;
    dispatch(
      fetchTweet(tweetid, (feed) => {
        const channel = pusher.subscribe(`topic-${feed.id}-details`);
        channel.bind("update-topic", (response) => {
          dispatch(FETCHING_TWEET_SUCCESS(response));
        });
      })
    );
    cleanupEventListener = () => {
      pusher.unsubscribe(`topic-${tweetid}-details`);
    };

    // Clean up the event listener when the component unmounts
    return cleanupEventListener;
  }, [tweetid, dispatch]);

  const handleUpvote = async () => {
    try{
      dispatch(TWEET_LIKED_SUCCESS());
      await upvoteOpenProject(tweet.id);
      cogoToast.success("تم تأييد المشروع");

    } catch(error){
      console.log(error);
    }
  };
  const handleReaction = async (vote_type, vote_count_type, message) => {
    await reactToProject(tweet.id, vote_type);
    cogoToast.success(message);
    dispatch(
      CONSTITUTION_TWEET_LIKED_SUCCESS({
        vote_type,
        vote_count_type,
      })
    );
  };

  const renderButtons = () => {
    return tweet.topic_level_id == 1 ? (
      <TextButton
        disabled={fetching}
        onClick={() => handleUpvote()}
        style={{ background: "green", color: "#fff", borderRadius: 20 }}
      >
        تأييد المشروع
      </TextButton>
    ) : (
      <div style={{ width: "100%" }}>
        <TextButton
          disabled={fetching}
          onClick={() =>
            handleReaction("approve", "approved_count", "تم تأييد الاستفتاء")
          }
          style={{
            margin: "1rem",
            background: "#46A11E",
            color: "#fff",
            borderRadius: 20,
          }}
        >
          تأييد الاستفتاء
        </TextButton>
        <TextButton
          disabled={fetching}
          onClick={() =>
            handleReaction(
              "disapprove",
              "disapproved_count",
              "تم رفض الاستفتاء"
            )
          }
          style={{
            margin: "1rem",
            background: "#E53209",
            color: "#fff",
            borderRadius: 20,
          }}
        >
          رفض الاستفتاء
        </TextButton>
        <TextButton
          disabled={fetching}
          onClick={() =>
            handleReaction("delay", "delayed_count", "تم تأجيل الاستفتاء")
          }
          style={{
            margin: "1rem",
            background: "#041259",
            color: "#fff",
            borderRadius: 20,
          }}
        >
          تأجيل الاستفتاء
        </TextButton>
      </div>
    );
  };

  const canVote = () => {
    switch (tweet.topic_category_id) {
      case 1:
        return true;
      case 2:
        if (tweet.state_id == currentUser.state_id) {
          return true;
        } else {
          return false;
        }
      case 3:
        if (tweet.locality_id == currentUser.locality_id) {
          return true;
        } else {
          return false;
        }
      default:
        return false;
    }
  };

  const getWinnerButton = () => {
    switch (tweet.winner_status) {
      case "approved":
        return (
          <>
            <TextButton
              disabled
              style={{ background: "#46A11E", color: "#fff" , marginBottom:"1rem" }}
            >
              تم قبول الاستفتاء على المشروع بتصويت الأغلبية{" "}
            </TextButton>
            <TextButton
              style={{ background: "rgb(30 46 161)", color: "#fff" }}
              onClick={()=>{navigate('/path')}}
            >
              مسار تنفيذ القرار
            </TextButton>
          </>
        );

      case "disapproved":
        return (
          <TextButton disabled style={{ background: "#E53209", color: "#fff" }}>
            تم رفض الاستفتاء على المشروع بتصويت الأغلبية{" "}
          </TextButton>
        );

      case "delayed":
        return (
          <TextButton disabled style={{ background: "#041259", color: "#fff" }}>
            تم تأجيل الاستفتاء على المشروع بتصويت الأغلبية{" "}
          </TextButton>
        );

      default:
        return "";
    }
  };
  return (
    <>
      <div className="tweetpage two-flex-col-container w-100">
        <div className="col1 fpc-1">
          {/* <UserHeader customHeader='Tweet'/> */}

          {!fetchingTweetError && (
            <div className="user-tweet-content" style={{ borderRadius: 10 }}>
              {fetching ? (
                <SimpleSpinner topCenter />
              ) : (
                <>
                  <div className="tweet tweet-container" style={{ dir: "rtl" }}>
                    {/* <div className="profile-pic-container">
                    <img src={getImage(tweet.topic_assets)} alt="user-pic" className="profile-pic" />
                  </div> */}
                    <div className="tweet-content">
                      <div className="tweet-content-header">
                        <span onClick={goBack}>
                          <BackIcon style={{ cursor: "pointer" }} />
                        </span>
                        <div className="tweet-header-child">
                          <span className="tweet-content-child timestamp">
                            {fToNowAr(tweet.created_at)}
                          </span>
                        </div>

                        <div className="tweet-header-child">
                          <span className="tweet-content-child timestamp">
                            {tweet.topic_category_id === 1
                              ? "قرار مجلس"
                              : tweet?.state?.name
                              ? tweet?.state?.name
                              : tweet?.locality?.name}
                          </span>
                        </div>
                        <div className="tweet-header-child">
                          <span className="tweet-content-child timestamp">
                            المعرف: {tweet?.id}
                          </span>
                        </div>
                      </div>
                      <div className="tweet-content-text">
                        <br />
                        <h2 className="tweet-text">{tweet.title}</h2>

                        <br />
                        <p className="tweet-text">{tweet.description}</p>
                      </div>

                      {tweet.topic_level_id == 1 && (
                        <h3 className="tweet-text">
                          عدد المؤيدين : {tweet.upvote_count}
                        </h3>
                      )}
                      {tweet.topic_level_id > 1 && (
                        <ApexChart
                          series={[
                            {
                              name: "Servings",
                              data: [
                                tweet.approved_count,
                                tweet.disapproved_count,
                                tweet.delayed_count,
                              ],
                            },
                          ]}
                          type="bar"
                          options={{
                            locales: [locale],
                            defaultLocale: "ar",
                            chart: {
                              height: 350,
                              type: "bar",
                            },
                            plotOptions: {
                              bar: {
                                // borderRadius: 10,
                                columnWidth: "50%",
                              },
                            },
                            dataLabels: {
                              enabled: true,
                            },
                            stroke: {
                              width: 2,
                            },

                            grid: {
                              row: {
                                colors: ["#fff", "#f2f2f2"],
                              },
                            },
                            xaxis: {
                              labels: {
                                rotate: 0,
                              },
                              categories: ["التأييد", "الرفض", "التأجيل"],
                              tickPlacement: "on",
                            },
                            yaxis: {
                              title: {
                                text: "عدد الاشخاص",
                              },
                            },

                            fill: {
                              type: "gradient",
                              gradient: {
                                shade: "light",
                                type: "horizontal",
                                shadeIntensity: 0.25,
                                gradientToColors: undefined,
                                inverseColors: true,
                                opacityFrom: 0.85,
                                opacityTo: 0.85,
                                stops: [50, 0, 100],
                              },
                            },
                          }}
                        />
                      )}
                      <div className="tweet-pic-grid-wrapper">
                        {tweet.topic_assets &&
                          tweet.topic_assets.map((el, index) => (
                            <div
                              key={index}
                              style={
                                el.asset_type == "pdf"
                                  ? { height: "36rem" }
                                  : {}
                              }
                              className="tweet-pic"
                            >
                              {el.asset_type == "pdf" ? (
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                  <Viewer
                                    renderError={() => ""}
                                    renderLoader={() => <SimpleSpinner />}
                                    fileUrl={BASE_WEB_URL + el.asset_file}
                                  />
                                  ;
                                </Worker>
                              ) : (
                                <embed
                                  src={BASE_WEB_URL + el.asset_file}
                                  alt="tweet-attachment"
                                  className="tweet-attachment-pic w-100 h-100"
                                />
                              )}
                            </div>
                          ))}
                        {/* {tweet.topic_assets.map(el => <embed className="tweet-content-image" src={  }/>)} */}
                        {/* {tweet.media_type === 1 && tweet.pic && (
                        <img
                          src={tweet.pic}
                          alt="tweet-pic"
                          className="tweet-content-image"
                        />
                      )}
                      {tweet.media_type === 2 && <Video src={tweet.video_src} />} */}
                      </div>

                      <div className="tweet-actions">
                        <div className="wrap-tweet-actions-child">
                          {tweet.topic_level_id == 2 &&
                            !tweet.is_voted &&
                            canVote() &&
                            renderButtons()}
                          {tweet.topic_level_id > 1 && (
                            <div className="tweet-actions-child like-tweet">
                              {tweet.is_voted == "approve" && (
                                <span className="tweet-comment-count">
                                  لقد قمت بتأييد الاستفتاء
                                </span>
                              )}

                              {tweet.is_voted == "disapprove" && (
                                <span className="tweet-comment-count">
                                  لقد قمت برفض الاستفتاء
                                </span>
                              )}

                              {tweet.is_voted == "delay" && (
                                <span className="tweet-comment-count">
                                  لقد قمت بتأجيل الاستفتاء
                                </span>
                              )}
                            </div>
                          )}

                          {tweet.topic_level_id == 1 && (
                            <div className="tweet-actions-child like-tweet">
                              {tweet.upvoted ? (
                                <span className="tweet-comment-count">
                                  لقد قمت بتأييد المشروع
                                </span>
                              ) : canVote() ? (
                                renderButtons()
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      {tweet.topic_level_id > 2 && getWinnerButton()}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {fetchingTweetError && <NotFound />}
        </div>
        {/* <div className="col2 tweet-sugg-news-container">
          <div className="tweet-sugg-news-wrap">
            <Searchbar input={searchQuery} setInput={(value)=>setSearchQuery(value)}/>
            <News />
          </div>
        </div> */}
      </div>
    </>
  );
}
